"use strict";

exports.__esModule = true;
exports.textAlignClasses = exports.TEXT_ALIGN = void 0;
var _consts = require("../../utils/mediaQuery/consts");
let TEXT_ALIGN = /*#__PURE__*/function (TEXT_ALIGN) {
  TEXT_ALIGN["START"] = "start";
  TEXT_ALIGN["CENTER"] = "center";
  TEXT_ALIGN["END"] = "end";
  TEXT_ALIGN["JUSTIFY"] = "justify";
  TEXT_ALIGN["LEFT"] = "left";
  TEXT_ALIGN["RIGHT"] = "right";
  return TEXT_ALIGN;
}({});
exports.TEXT_ALIGN = TEXT_ALIGN;
const textAlignClasses = {
  [TEXT_ALIGN.START]: "text-start",
  [TEXT_ALIGN.CENTER]: "text-center",
  [TEXT_ALIGN.END]: "text-end",
  [TEXT_ALIGN.JUSTIFY]: "text-justify",
  [TEXT_ALIGN.LEFT]: "text-left",
  [TEXT_ALIGN.RIGHT]: "text-right",
  [_consts.QUERIES.MEDIUMMOBILE]: {
    [TEXT_ALIGN.START]: "mm:text-start",
    [TEXT_ALIGN.CENTER]: "mm:text-center",
    [TEXT_ALIGN.END]: "mm:text-end",
    [TEXT_ALIGN.JUSTIFY]: "mm:text-justify",
    [TEXT_ALIGN.LEFT]: "mm:text-left",
    [TEXT_ALIGN.RIGHT]: "mm:text-right"
  },
  [_consts.QUERIES.LARGEMOBILE]: {
    [TEXT_ALIGN.START]: "lm:text-start",
    [TEXT_ALIGN.CENTER]: "lm:text-center",
    [TEXT_ALIGN.END]: "lm:text-end",
    [TEXT_ALIGN.JUSTIFY]: "lm:text-justify",
    [TEXT_ALIGN.LEFT]: "lm:text-left",
    [TEXT_ALIGN.RIGHT]: "lm:text-right"
  },
  [_consts.QUERIES.TABLET]: {
    [TEXT_ALIGN.START]: "tb:text-start",
    [TEXT_ALIGN.CENTER]: "tb:text-center",
    [TEXT_ALIGN.END]: "tb:text-end",
    [TEXT_ALIGN.JUSTIFY]: "tb:text-justify",
    [TEXT_ALIGN.LEFT]: "tb:text-left",
    [TEXT_ALIGN.RIGHT]: "tb:text-right"
  },
  [_consts.QUERIES.DESKTOP]: {
    [TEXT_ALIGN.START]: "de:text-start",
    [TEXT_ALIGN.CENTER]: "de:text-center",
    [TEXT_ALIGN.END]: "de:text-end",
    [TEXT_ALIGN.JUSTIFY]: "de:text-justify",
    [TEXT_ALIGN.LEFT]: "de:text-left",
    [TEXT_ALIGN.RIGHT]: "de:text-right"
  },
  [_consts.QUERIES.LARGEDESKTOP]: {
    [TEXT_ALIGN.START]: "ld:text-start",
    [TEXT_ALIGN.CENTER]: "ld:text-center",
    [TEXT_ALIGN.END]: "ld:text-end",
    [TEXT_ALIGN.JUSTIFY]: "ld:text-justify",
    [TEXT_ALIGN.LEFT]: "ld:text-left",
    [TEXT_ALIGN.RIGHT]: "ld:text-right"
  }
};
exports.textAlignClasses = textAlignClasses;